import axios from 'axios'

require('es6-promise').polyfill();

const clientInstance = axios.create({  
	timeout: 10000, 
	headers: {'x-ajax-call': true} 
});

clientInstance.interceptors.response.use(function (response) {

    return response;
}, function (error) {

    if(error.response) {
        if(error.response.data) {
          //  console.error(error.response.data)
        }
        if(error.response.status === 401) {
            document.location.href = "/login?logout=true";
        }
    }

    return Promise.reject(error);
});


export default clientInstance;




// WEBPACK FOOTER //
// ./src/main/frontend/vue/js/api/Http.js